import React from 'react';
import styled from 'styled-components';
import { SectionHeader, Link } from '@grnhse/seedling/lib/birch/typography';
import { FullPalette } from '@grnhse/seedling/lib/birch/colors';
import CandidateChips from 'talent_matching/components/shared/candidate_chips';
import { Stack } from '@grnhse/seedling/lib/birch/layouts/stack_v2';
import { Person } from 'talent_matching/types';
import { Row } from 'shared/components/birch/row';
import Bookmark from 'talent_matching/components/shared/bookmark';
import { FraudIcon } from 'fraud/fraud_icon';
import { useTalentMatchingTabContext } from 'talent_matching/contexts/talent_matching_tab_context';

const HeaderLink = styled.div`
  &&& > a {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

const CandidateName = styled(SectionHeader)`
  color: ${FullPalette.EVERGREEN_700};
`;

const SidePanelHeader = ({
  application,
  onDuplicateClick,
}: {
  application: Person;
  onDuplicateClick?: () => void;
}) => {
  const profileUrl = `/people/${application?.personId}/applications/${application?.id}`;
  const { fraudReportHighRisk } = application;
  const { canViewFraudReports } = useTalentMatchingTabContext();

  const showFraudIcon = canViewFraudReports && fraudReportHighRisk;

  return (
    <Stack spacing={1} sx={{ width: '100%' }}>
      <Row spacing={1} alignItems={'center'}>
        <HeaderLink>
          <Link href={profileUrl} target="_blank">
            <CandidateName large>
              <span className="pii-blur">{application.fullName}</span>
            </CandidateName>
          </Link>
        </HeaderLink>
        {showFraudIcon && <FraudIcon size="md" />}
        <Bookmark application={application} size="lg" />
      </Row>
      <CandidateChips
        application={application}
        showTags
        onDuplicateClick={onDuplicateClick}
      />
    </Stack>
  );
};

export default SidePanelHeader;
